import './Text.css';
import React, { useState } from 'react';

export function Preach() {
    const [DvYQDzQHNLo] = useState('DvYQDzQHNLo')
  return (
    <div class="body">
      <div class="row">
        <iframe  allow="fullscreen *"
frameborder="0"
        title='Freedom School'
        
        src={`https://youtube.com/embed/${DvYQDzQHNLo}?autoplay=0`}>
</iframe>
      </div>
            <div class="row" id="GalleryThree">
  <div class="column" id="centered">   
                   <hr/> <br/> <h2> P.R.E.A.C.H. </h2>
                    <h4>2025
                        <br/>
            Open Mic with worksheets hosted by the Black Artist Union at the Minneapolis College of Art and Design<br/><br/>
<b>Research question:</b> <br/>
How do we Practice, Reconciliation, Anger, Entertainment, Community, and Hope, in a way that resists violence?
</h4>
<br/><hr/><br/>
             <h2>How Can You Love Someone Who Wants You Dead?</h2><h4> 
2025
                          <br/>
Video Essay.
             <br/><br/> Learning about how community can function under conflict, using
Martin Luther King readings, Nina Simone’s music, and audience research from a poetry event.</h4>
<br/>
<hr/>
</div>

             <div class="column">  <a target="0" href="https://youtu.be/DvYQDzQHNLo?si=0BGWuzN9mp2gsJqg">
               <img src="Preach1.jpg"></img>
            </a>
           


                </div>

             <div class="column" id="centered">
<img src="Preach2.jpg"></img>
</div>


</div>

<div class="row" id="GalleryThree">

<div class="column">
<img src="Preach8.jpg"></img>
</div>

<div class="column">
<img src="Preach4.jpg"></img>
</div>
<div class="column">
<img src="Preach5.jpg"></img>
</div>
<div class="column">
<img src="Preach6.jpg"></img>
</div>
<div class="column">
<img src="Preach7.jpg"></img>
</div>
<div class="column">
<img src="Preach3.jpg"></img>
</div>
<div class="column">
<img src="Preach9.jpg"></img>
</div>
<div class="column">
<img src="Preach10.jpg"></img>
</div>
<div class="column">
<img src="Preach11.jpg"></img>
</div>
<div class="column">
<img src="Preach12.jpg"></img>
</div>
<div class="column">
<img src="Preach13.jpg"></img>
</div>
<div class="column">
<img src="Preach14.jpg"></img>
</div>
<div class="column">
<img src="Preach15.jpg"></img>
</div>
<div class="column">
<img src="Preach16.jpg"></img>
</div>
<div class="column">
<img src="Preach17.jpg"></img>
</div>
<div class="column">
<img src="Preach18.jpg"></img>
</div>
<div class="column">
<img src="Preach19.jpg"></img>
</div>
<div class="column">
<img src="Preach20.jpg"></img>
</div>
<div class="column">
<img src="Preach21.jpg"></img>
</div>
<div class="column">
<img src="Preach22.jpg"></img>
</div>
<div class="column">
<img src="Preach23.jpg"></img>
</div>
<div class="column">
<img src="Preach24.jpg"></img>
</div>
<div class="column">
<img src="Preach25.jpg"></img>
</div>
<div class="column">
<img src="Preach26.jpg"></img>
</div>
<div class="column">
<img src="Preach27.jpg"></img>
</div>


</div></div>


  );
}
